module.exports = __webpack_public_path__ + "img/2220a1b.jpg";